export default "__VITE_ASSET__BIw8Oorl__"